import { DateTime } from 'luxon'

export default {
  methods: {
    // search.range is the user's stated preference and is persisted to localStorage; the
    // anonymous cap is a query-time concern that can change independently (e.g. session
    // restoring after mount) and must never mutate that persisted value. So the cap is applied
    // here, at the single choke point where a range becomes an actual request, rather than by
    // clamping search.range itself.
    searchRangeToQuery: function(searchRange) {
      const cap = this.$store.state.anonymousHistoryDays
      let effectiveRange = searchRange
      if (cap != null && (effectiveRange == null || effectiveRange < 0 || effectiveRange > cap)) {
        effectiveRange = cap
      }

      if (effectiveRange != null && effectiveRange > 0) {
        this.$log.info(`Using search range: ${effectiveRange}`)
        return `?from=${DateTime.local().minus({ days: effectiveRange }).toISODate()}`
      }

      return ""
    },
  },
};
